import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ActoCondicionModel } from 'src/app/models/acto-condicion/ActoCondicionModel';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { IActoCondicionModel } from 'src/app/models/interfaces/acto-condicion/IActoCondicionModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { ActoCondicionService } from 'src/app/services/acto-condicion/acto-condicion.service';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  templateUrl: './configuracion-acto-condicion-registrar.component.html',
  styleUrls: ['./configuracion-acto-condicion-registrar.component.css']
})
export class ConfiguracionActoCondicionRegistrarComponent implements OnInit {
  model: IActoCondicionModel = new ActoCondicionModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private router: Router,
    private gbuService: ActoCondicionService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.gbuService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open("El Acto - Condición fue registrado");
            this.router.navigate(['/configuracion', 'actos-condicion']);  
          });
        }
      });
    }
  }

}
